import { IntlShape } from 'react-intl';
import { WITHOUT_SPACES_REGEX_EXP } from '../../constants/regex.constants';
import { AttendanceType, RestrictAccessFilter } from '../../api/custom-pages.dao';
import { noneAsNullOrUndefined } from '../../components/_events/_manage-event/_edit-website/website-form-body/passport-pages/default-pages/restrict-access-container';

export const getErrorMessage = (intl: IntlShape, templateNames: string[]) => {
    let shouldShowErrorMessage = false;
    let defaultMessage = 'Please correct fields validation on ';
    let id = 'oe.website.responsiveEmails.templates.error.';

    if (!templateNames.length) return null;

    templateNames.forEach(name => {
        defaultMessage += `${shouldShowErrorMessage ? ', ' : ''} ${name}`;
        id += name.replace(WITHOUT_SPACES_REGEX_EXP, '');
        if (!shouldShowErrorMessage) shouldShowErrorMessage = true;
    });

    return intl.formatMessage({
        defaultMessage: defaultMessage + ' Template',
        id: id,
        description: 'error message text'
    });
};

const attendanceTypesToTextMapping = {
    [AttendanceType.InPerson]: 'In Person',
    [AttendanceType.Virtual]: 'Virtual',
    [AttendanceType.Both]: 'Both'
};

export function getFilterNamesByFilterType(type: keyof RestrictAccessFilter, filters: string[]) {
    switch (type) {
        case 'allowedAttendanceMethods':
            return filters.map(el => attendanceTypesToTextMapping[el]);
        case 'allowedOrganizationTypes':
            const noneAsNullOrUndefinedIndex = filters.findIndex(f => f === noneAsNullOrUndefined);
            return noneAsNullOrUndefinedIndex !== -1
                ? filters.map(filter => filter === noneAsNullOrUndefined ? '<i>None</i>' : filter)
                : filters;
        default:
            return filters;
    }
}